import React from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'V4VideoLoaderListing' */ '../LitePlayer/Player'),
  loading: () => null,
});

export default class V4VideoLoaderListing extends React.Component {
  render() {
    const newProps = {
      agency: 'TOI',
      tplPos: 'widget',
      autoplay: this.props.autoplay,
      tmplSource: this.props.tmplSource,
      bl: '0',
      divId: this.props.playerContainerId || 'lg_player_id',
      globalRefId: this.props.globalRefId || `lg_videowidget`,
      // headless: true,
      videoInloop: false,
      isFullPlayer: true,
      mute: true,
      playerContainerId: this.props.playerContainerId || 'lg_player_id',
      shareUrl: '',
      titleStr: '',
      isVideoSkipAds: false,
      msid: this.props.msid,
      skipAnalytics: false,
      skipMultiInstance: false,
      fgResume: false,
      defaultVolume: 80,
      playInBackground: false,
      analytics: {
        pageSection: this.props.sectionName,
        isPrime: this.props.isUserPrime,
        pageUrl: typeof window !== 'undefined' ? window?.location?.href : '',
        pageTpl: this.props.pageTpl,
      },
      recoConfig: {
        reco: false,
        onpauseshow: false,
        onendshow: false,
        onsize: 300,
      },
    };

    // Combining props
    const allProps = {
      ...this.props,
      ...newProps,
    };
    return <LoadableComponent {...allProps} />;
  }
}

V4VideoLoaderListing.propTypes = {
  autoplay: PropTypes.bool,
  tmplSource: PropTypes.string,
  playerContainerId: PropTypes.string,
  globalRefId: PropTypes.string,
  msid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sectionName: PropTypes.string,
  isUserPrime: PropTypes.bool,
  pageTpl: PropTypes.string,
};

V4VideoLoaderListing.defaultProps = {
  autoplay: false,
  tmplSource: '',
  playerContainerId: 'lg_player_id',
  globalRefId: 'lg_videowidget',
  msid: '',
  sectionName: '',
  isUserPrime: false,
  pageTpl: '',
};
